// 9-12 Educators PD Conference data — modeled exactly on Pre K PD app structure
// with 9-12 specific changes (3 groups, 3 sessions, CDW+Newline sponsors, etc.)

export const CONFERENCE = {
  title: "BCS District PD Conference",
  tagline: "Nurture. Guide. Empower.",
  subTagline: "AI in Teaching & Learning",
  audience: "9-12 educators",
  audienceSegment: "secondary",
  date: "June 8, 2026",
  year: 2026,
  registrationNumber: "344915",
  registrationDeadline: "May 31, 2026",
  ceus: 12,
  schoologyAccessCode: "QM79-25D5-J63TQ",
  welcome:
    "Welcome, 9-12 educators! Today we explore how AI can support, inspire, and elevate secondary teaching.",
};

// Hero background image (same one Pre K uses)
export const HERO_BG_URL =
  "https://images.unsplash.com/photo-1755538497211-c4ebc7cc1a94?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHwzfHxhYnN0cmFjdCUyMHRlY2hub2xvZ3klMjBlZHVjYXRpb24lMjBiYWNrZ3JvdW5kfGVufDB8fHx8MTc3NzIzNTU2MHww&ixlib=rb-4.1.0&q=85";

// Local logo paths (copied from Pre K repo)
export const BCS_LOGO = "/bcs-logo.png";

// Lunch sponsors (CDW & Newline) — served locally from /public so they
// don't depend on external customer-asset URLs that may break on production.
export const LUNCH_SPONSORS = [
  {
    name: "CDW",
    logo: "/cdw-logo.png",
    url: "https://www.cdw.com/",
  },
  {
    name: "Newline Interactive",
    logo: "/newline-logo.png",
    url: "https://newline-interactive.com/",
  },
];

// Agenda items for 9-12 (new times + content)
export const AGENDA = [
  {
    id: "morning",
    time: "7:30 - 8:30 AM",
    title: "Morning of Line Dancing, D9 Strolling, Exercising, DJ, Music, and Entertainment",
    description: "All groups attend. Kick off the day, get moving, and find your group!\n\nClick on My Group to determine your assigned group.",
    location: "Auditorium - Room 1100",
    type: "general",
  },
  {
    id: "keynote",
    time: "8:30 - 9:15 AM",
    title: "Keynote: Richard Culatta, CEO, ISTE+ASCD",
    description: "Welcome and opening keynote address.",
    location: "Auditorium - Room 1100",
    type: "keynote",
  },
  {
    id: "s1",
    time: "9:30 - 10:30 AM",
    title: "Session 1",
    description: "First session — see Group Rotation for your assigned room.",
    location: "Various",
    type: "rotation",
  },
  {
    id: "s2",
    time: "10:45 - 11:45 AM",
    title: "Session 2",
    description: "Second session — see Group Rotation for your assigned room.",
    location: "Various",
    type: "rotation",
  },
  {
    id: "lunch",
    time: "11:45 AM - 1:00 PM",
    title: "Lunch",
    description: "All groups break for lunch together.",
    location: "Cafeteria - Room 153",
    type: "break",
  },
  {
    id: "s3",
    time: "1:15 - 2:15 PM",
    title: "Session 3",
    description: "Third session — see Group Rotation for your assigned room.",
    location: "Various",
    type: "rotation",
  },
];

// 3 sessions (no Blue group / Blue session)
export const SESSIONS = [
  {
    id: "ai-secondary",
    title: "AI in Secondary Education",
    location: "Computer Labs 1146, 1171, 1174, 1178, 1180, 124, 281, or 252",
    description:
      "AI in High School Education, led by ISTE trainers, is a professional learning session designed specifically for grades 9–12 teachers to explore how artificial intelligence can support rigorous instruction, student engagement, and future-ready learning in high school classrooms. Participants will examine practical AI applications for lesson design, critical thinking, student creativity, assessment support, and academic integrity. The session will also address ethical use, responsible implementation, and the importance of maintaining teacher judgment and student ownership of learning. By the end of the session, high school educators will leave with strategies and resources to integrate AI thoughtfully, safely, and effectively into secondary instruction.",
    icon: "sparkles",
  },
  {
    id: "ai-prompting",
    title: "AI Prompting and MagicSchool AI",
    location: "Rooms 1117, 1125, 1126, 1129, 1130, 1131, 1132, or 1133",
    description:
      "Hands on workshop led by EdFarm, is a professional learning session that helps educators explore effective AI prompting strategies and practical classroom applications using MagicSchool AI. Participants will learn how to use AI to support lesson planning, differentiation, assessments, and communication while gaining a stronger understanding of responsible and ethical AI use in education.",
    icon: "wand",
  },
  {
    id: "schoology-gems",
    title: "Schoology GEMS",
    location: "Rooms 1145, 1149, 1150, 120, 121, 142, 144, or 145",
    description:
      "A hands-on professional learning session designed to help educators discover practical strategies and hidden features within Schoology that enhance organization, communication, personalization, and student engagement. Participants will explore classroom-ready tools and techniques that support the creation of polished, student-centered digital learning experiences for learners at all levels.",
    icon: "shield",
  },
];

// 3 GROUPS — Blue removed, mirroring Pre K group structure
export const GROUPS = [
  {
    id: "learning_architects",
    name: "Learning Architects",
    bandLabel: "Green Band",
    color: "#2F855A",
    accent: "#FFFFFF",
    icon: "construct",
  },
  {
    id: "digital_designers",
    name: "Digital Designers",
    bandLabel: "Red Band",
    color: "#C53030",
    accent: "#FFFFFF",
    icon: "palette",
  },
  {
    id: "integration_engineers",
    name: "Integration Engineers",
    bandLabel: "Yellow Band",
    color: "#F6B829",
    accent: "#FFFFFF",
    icon: "network",
  },
];

// Per-group rotation through ALL three sessions (each group hits each session once)
export const ROTATIONS = {
  learning_architects: [
    { time: "7:30 - 8:30 AM", session: "Morning of Line Dancing, D9 Strolling, Exercising, DJ, Music, and Entertainment", location: "Auditorium - Room 1100" },
    { time: "8:30 - 9:15 AM", session: "Keynote: Richard Culatta, CEO, ISTE+ASCD", location: "Auditorium - Room 1100" },
    { time: "9:30 - 10:30 AM", session: "Schoology GEMS", location: "Rooms 1145, 1149, 1150, 120, 121, 142, 144, or 145" },
    { time: "10:45 - 11:45 AM", session: "AI in Secondary Education", location: "Computer Labs 1146, 1171, 1174, 1178, 1180, 124, 281, or 252" },
    { time: "11:45 AM - 1:00 PM", session: "Lunch", location: "Cafeteria - Room 153" },
    { time: "1:15 - 2:15 PM", session: "AI Prompting and MagicSchool AI", location: "Rooms 1117, 1125, 1126, 1129, 1130, 1131, 1132, or 1133" },
  ],
  digital_designers: [
    { time: "7:30 - 8:30 AM", session: "Morning of Line Dancing, D9 Strolling, Exercising, DJ, Music, and Entertainment", location: "Auditorium - Room 1100" },
    { time: "8:30 - 9:15 AM", session: "Keynote: Richard Culatta, CEO, ISTE+ASCD", location: "Auditorium - Room 1100" },
    { time: "9:30 - 10:30 AM", session: "AI in Secondary Education", location: "Computer Labs 1146, 1171, 1174, 1178, 1180, 124, 281, or 252" },
    { time: "10:45 - 11:45 AM", session: "AI Prompting and MagicSchool AI", location: "Rooms 1117, 1125, 1126, 1129, 1130, 1131, 1132, or 1133" },
    { time: "11:45 AM - 1:00 PM", session: "Lunch", location: "Cafeteria - Room 153" },
    { time: "1:15 - 2:15 PM", session: "Schoology GEMS", location: "Rooms 1145, 1149, 1150, 120, 121, 142, 144, or 145" },
  ],
  integration_engineers: [
    { time: "7:30 - 8:30 AM", session: "Morning of Line Dancing, D9 Strolling, Exercising, DJ, Music, and Entertainment", location: "Auditorium - Room 1100" },
    { time: "8:30 - 9:15 AM", session: "Keynote: Richard Culatta, CEO, ISTE+ASCD", location: "Auditorium - Room 1100" },
    { time: "9:30 - 10:30 AM", session: "AI Prompting and MagicSchool AI", location: "Rooms 1117, 1125, 1126, 1129, 1130, 1131, 1132, or 1133" },
    { time: "10:45 - 11:45 AM", session: "Schoology GEMS", location: "Rooms 1145, 1149, 1150, 120, 121, 142, 144, or 145" },
    { time: "11:45 AM - 1:00 PM", session: "Lunch", location: "Cafeteria - Room 153" },
    { time: "1:15 - 2:15 PM", session: "AI in Secondary Education", location: "Computer Labs 1146, 1171, 1174, 1178, 1180, 124, 281, or 252" },
  ],
};

export const KEYNOTE = {
  name: "Richard Culatta",
  title: "CEO, ISTE+ASCD",
  image:
    "https://customer-assets.emergentagent.com/job_deploy-base44/artifacts/1iktafnc_image.png",
  bio: "Following the 2023 merger of the International Society for Technology in Education (ISTE) and the Association for Supervision and Curriculum Development (ASCD), Richard Culatta leads the combined organization focused on transforming learning through technology and effective pedagogy. He has served as CEO of ISTE since 2017 and now oversees the unified ISTE+ASCD entity. Prior to this role, he was the Chief Innovation Officer for the state of Rhode Island and served as Director of the Office of Educational Technology at the U.S. Department of Education under President Obama. Culatta is widely recognized for advancing innovation in education, digital citizenship, and the effective use of AI in classrooms. He is also the author of Digital for Good: Raising Kids to Thrive in an Online World.",
};

export const RESOURCES = [
  { label: "AMSTI Summer Learning", url: "https://www.canva.com/design/DAHGY8G4Xws/-7-h2EqGRs-RKsv2mTrj_g/view" },
  { label: "UAB Regional Inservice Center Region 5 Summer PD", url: "https://simplebooklet.com/region5summerlearning2026p#page=1" },
];
